export const queries = {
  sm: "@media(max-width: 640px)",
  md: "@media(max-width: 768px)",
  lg: "@media(max-width: 1024px)",
};

export const colors = {
  dark: "#000",
};
